module.exports = "/_next/static/images/bitcoin_b-5127411983675b716ec6cc2363602c86.png";